import Avatar from '@/components/common/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AI_ASSISTANT_AVATAR } from '../../constants';

interface ChatEmptyStateProps {
  keyword?: string;
}

const ChatEmptyState = ({ keyword }: ChatEmptyStateProps) => {
  const displayKeyword = keyword ? decodeURIComponent(keyword) : null;

  return (
    <div className="d-flex flex-column align-items-center justify-content-center text-center px-4 py-5">
      <Avatar src={AI_ASSISTANT_AVATAR} size="4xl" />
      <h6 className="fw-semibold text-600 mt-3 mb-2">
        {displayKeyword
          ? `آماده تحلیل «${displayKeyword}» هستیم`
          : 'گفتگو با دستیار AI'}
      </h6>
      <p className="text-600 fs--1 mb-3 w-75">
        دستیار هوش مصنوعی می‌تواند روند رتبه، نقاط قوت و ضعف و پیشنهادهای
        عملی برای بهبود سئو این کلمه را برای شما توضیح دهد.
      </p>
      <div className="d-flex flex-column gap-2 w-75 fs--1 text-700 text-end">
        <div className="bg-100 rounded-2 p-2 d-flex gap-2 align-items-start">
          <FontAwesomeIcon icon="comments" className="text-primary mt-1" />
          <span>سؤال خود را در کادر پایین بنویسید و ارسال کنید.</span>
        </div>
        <div className="bg-100 rounded-2 p-2 d-flex gap-2 align-items-start">
          <FontAwesomeIcon icon="sync-alt" className="text-primary mt-1" />
          <span>
            با «تحلیل مجدد» روند رتبه در بازه‌های زمانی مختلف را ببینید.
          </span>
        </div>
        <div className="bg-100 rounded-2 p-2 d-flex gap-2 align-items-start">
          <FontAwesomeIcon icon="search" className="text-primary mt-1" />
          <span>
            با «تحقیق کلمه» ایده‌ها و کلمات مرتبط پیشنهادی دریافت کنید.
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChatEmptyState;
